import React, { FC } from 'react';

import { CombinedError } from 'urql';

import MuiIcon from '../../../MuiIcon';

import NoResult from '../../NoResults';

import { DataType } from '../types';

import * as Styled from './styled';

export type Props = {
  dataSelected: string | null;
  dataVisible: DataType[];
  error?: CombinedError;
  isLoading: boolean;
  isSearching: boolean;
  requestDataSelect: (id: DataType['id']) => void;
  type: 'template' | 'topic';
};

/**
 * List used for picking template/topic
 *
 * @param props                   Props passed to the component
 * @param props.dataSelected      Currently selected data
 * @param props.dataVisible       Visible data
 * @param props.error             Data fetching error
 * @param props.isLoading         Whether the data is being loaded
 * @param props.isSearching       Whether something was typed into search
 * @param props.requestDataSelect Request that current data is changed
 * @param props.type              Type of the data (template or topic)
 * @returns                       The component itself
 */
const SearchList: FC<Props> = ({
  dataSelected,
  dataVisible,
  error,
  isLoading,
  isSearching,
  requestDataSelect,
  type,
}) => {
  if (error) {
    return <NoResult dataType={type} reason="error" />;
  }

  if (dataVisible.length === 0) {
    return isSearching === true ? (
      <NoResult dataType={type} reason="searching" />
    ) : null;
  }

  return (
    <Styled.SearchList>
      {dataVisible.map(({ id, title }) => {
        const isSelected = id === dataSelected;

        return (
          <Styled.SearchListItem
            disabled={isLoading}
            key={id}
            onClick={() => requestDataSelect(id)}
            selected={isSelected}
          >
            {isSelected && <MuiIcon fontSize="small" icon="check" />}
            <Styled.SearchListItemText>{title}</Styled.SearchListItemText>
          </Styled.SearchListItem>
        );
      })}
    </Styled.SearchList>
  );
};

export default SearchList;
